import type { PAGE_POSITIONS } from 'types';

import type { TrackedButtonClickName } from '~/services/gtm.client';
import gtm from '~/services/gtm.client';

import {
  Button,
  type ButtonProps,
  ExternalLink,
  type ExternalLinkProps,
  InternalLink,
  type InternalLinkProps
} from '../Button';

type Props = {
  children: React.ReactNode;
  name: TrackedButtonClickName;
  pagePosition: PAGE_POSITIONS | `TEMP_${string}`;
};

const TrackedExternalLink = ({
  children,
  onClick,
  name,
  pagePosition,
  ...props
}: Props & ExternalLinkProps) => {
  return (
    <ExternalLink
      {...props}
      onClick={(e) => {
        gtm.trackedButtonClick({ buttonName: name, pagePosition });

        if (onClick) onClick(e);
      }}
    >
      {children}
    </ExternalLink>
  );
};

const TrackedInternalLink = ({
  children,
  onClick,
  name,
  pagePosition,
  ...props
}: Props & InternalLinkProps) => {
  return (
    <InternalLink
      {...props}
      onClick={(e) => {
        gtm.trackedButtonClick({ buttonName: name, pagePosition });

        if (onClick) onClick(e);
      }}
    >
      {children}
    </InternalLink>
  );
};

const TrackedButton = ({
  children,
  onClick,
  name,
  pagePosition,
  ...props
}: Props & ButtonProps) => {
  return (
    <Button
      {...props}
      onClick={(e) => {
        gtm.trackedButtonClick({ buttonName: name, pagePosition });

        if (onClick) onClick(e);
      }}
    >
      {children}
    </Button>
  );
};

export default {
  Button: TrackedButton,
  ExternalLink: TrackedExternalLink,
  InternalLink: TrackedInternalLink
};
